import { ReactNode, useRef } from 'react'

import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { DialogProps, Snackbar, Tooltip } from '@mui/material'

import styles from './styles.module.scss'

type ModalProps = Omit<DialogProps, 'content'> & {
  title?: string | undefined
  content: string | ReactNode
  button?: ReactNode
  open: boolean
  height?: string | 'auto'
  textTooltip?: any
  footer?: React.ReactNode
  setScrollBottom?: (value: boolean) => void
}
export const AlertCard = ({
  title,
  content,
  open,
  height,
  textTooltip,
  footer,
  button,
  setScrollBottom,
}: ModalProps) => {
  const divContent = useRef<HTMLDivElement>(null)

  const checkScrollPosition = () => {
    if (divContent.current) {
      const divSize = divContent.current!.getBoundingClientRect()
      const scrolledHeight = divContent.current!.scrollHeight
      if (
        scrolledHeight - 10 <=
        divContent.current!.scrollTop + divSize.height
      ) {
        setScrollBottom && setScrollBottom(true)
      }
    }
  }

  const handleScroll = () => {
    checkScrollPosition()
  }

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <div className={styles.container} style={{ height: height }}>
        <div className={styles.header}>
          {title && (
            <div className={styles.title}>
              <h5>{title}</h5>
              {textTooltip && (
                <Tooltip title={textTooltip} placement="right">
                  <HelpOutlineIcon
                    fontSize="small"
                    className={styles.helpIcon}
                  />
                </Tooltip>
              )}
            </div>
          )}
        </div>
        <div
          className={styles.content}
          onScroll={handleScroll}
          ref={divContent}
        >
          {content}
          {button && <div className={styles.button}>{button}</div>}
        </div>
        {footer}
      </div>
    </Snackbar>
  )
}
